const cookiesBanner = document.querySelector('[js-cookies-banner]');
if (cookiesBanner) {
  const wrapper = cookiesBanner.querySelector('[js-cookies-banner-wrapper]');

  const KEY = 'cookies_banner_hidden_until';
  const ONE_DAY_MS = 24 * 60 * 60 * 1000;

  const hideBanner = () => {
    cookiesBanner.style.display = 'none';
  };

  const showBanner = () => {
    cookiesBanner.style.display = 'block';
  };

  const isHidden = () => {
    const until = Number(localStorage.getItem(KEY) || 0);
    return until > Date.now();
  };

  const hideForTwentyFourhours = () => {
    localStorage.setItem(KEY, String(Date.now() + ONE_DAY_MS));
    hideBanner();
  };
  hideBanner();
  if (!isHidden()) {
    setTimeout(() => showBanner(), 1000);
  }

  cookiesBanner.querySelectorAll('[js-cookies-banner-left-icons]').forEach((icons) => {
    icons.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      icons.classList.toggle('selected');
    });
  });

  cookiesBanner.querySelectorAll('[js-accordion-heading]').forEach((heading) => {
    heading.addEventListener('click', () => {
      const item = heading.closest('[js-cookies-banner-item]');
      if (!item) return;

      const content = item.querySelector('[js-accordion-body]');
      if (!content) return;

      const isOpen = item.classList.contains('is-open');

      cookiesBanner.querySelectorAll('[js-cookies-banner-item].is-open').forEach((openItem) => {
        openItem.classList.remove('is-open');
        const openContent = openItem.querySelector('[js-accordion-body]');
        if (openContent) openContent.style.maxHeight = '0px';
      });

      if (!isOpen) {
        item.classList.add('is-open');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });

  const acceptBtn = cookiesBanner.querySelector('[js-accept-cookies]');
  if (acceptBtn) {
    acceptBtn.addEventListener('click', (e) => {
      e.preventDefault();
      hideForTwentyFourhours();
    });
  }

  const acceptAsBtn = cookiesBanner.querySelector('[js-cookies-accept-as-button]');
  if (acceptAsBtn) {
    acceptAsBtn.addEventListener('click', (e) => {
      e.preventDefault();
      hideForTwentyFourhours();
    });
  }

  const saveBtn = cookiesBanner.querySelector('[js-cookies-save-button]');
  if (saveBtn) {
    saveBtn.addEventListener('click', (e) => {
      e.preventDefault();
      hideForTwentyFourhours();
    });
  }

  const settingsBtn = cookiesBanner.querySelector('[js-cookies-settings]');
  if (settingsBtn && wrapper) {
    settingsBtn.addEventListener('click', (e) => {
      e.preventDefault();
      wrapper.classList.add('active');
      showBanner();
    });
  }

  const description = cookiesBanner.querySelector('[js-cookies-description]');
  if (description && wrapper) {
    description.addEventListener('click', (e) => {
      if (e.target && e.target.closest && e.target.closest('a')) return;
      wrapper.classList.add('active');
      showBanner();
    });
  }
}
